/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/EnvironmentWarning/Content"
  
}) {
let appEnvironmentValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'environment',
})
let constantData = 'SITE ONLY - RESET DAILY'
let aggregateData = fromAggregate.join(appEnvironmentValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="red"
 style="filled"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="app.environment"
 data="'SITE ONLY - RESET DAILY'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
 textTransform="uppercase"
/>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}